
import Vue from 'vue'
import { mapActions, mapGetters } from 'vuex'

export default Vue.extend({
  computed: mapGetters(['categories']),

  methods: {
    trackClick(categoryId) {
      this.$store.dispatch('track_category_click', {
        categoryId,
      })
      const el = document.getElementById('category-' + categoryId)

      if (el) {
        el.scrollIntoView({
          behavior: 'smooth',
        })
      }
    },
  },
})
